import {
  SET_COOKIE_CONSENT,
  SET_DEVICE_TYPE,
  SET_MEASUREMENTS,
  SET_GA_USER_ID,
  SET_MOBILE_TYPE,
} from "@constants/action-types";

export const initialState = {
  cookieConsent: false,
  deviceType: undefined,
  mobileType: undefined,
  width: undefined,
};

const DeviceInfoReducer = (state, action) => {
  switch (action.type) {
    case SET_DEVICE_TYPE:
      return {
        ...state,
        deviceType: action.value,
      };
    case SET_MEASUREMENTS:
      return {
        ...state,
        width: action.value.width,
      };
    case SET_COOKIE_CONSENT:
      return {
        ...state,
        cookieConsent: action.value,
      };
    case SET_GA_USER_ID:
      return {
        ...state,
        analyticsId: action.value,
      };
    case SET_MOBILE_TYPE:
      return {
        ...state,
        mobileType: action.value,
      };
    default:
      return state;
  }
};

export default DeviceInfoReducer;
